import { Field as IField } from "@/core/types/types";
import { Box, Theme } from "@mui/system";
import Field from "@/core/components/Field";
import useCustomStyles from "@/core/hooks/useCustomStyles/useCustomStyles";

const styles = (theme: Theme) => ({
  root: {
    [theme.breakpoints.up("md")]: {
      display: "flex",
      gap: theme.spacing(2),
    },
    [theme.breakpoints.down("md")]: {
      "& > *:not(:last-child)": {
        marginBottom: theme.spacing(2),
      },
    },
  },
});

const RowFieldGroup = ({ groupItems }: { groupItems: IField[] }) => {
  const classes: any = useCustomStyles(styles);

  return (
    <Box sx={classes?.root}>
      {groupItems.map((field: IField) => (
        <Box key={field.id} width="100%">
          <Field field={field} />
        </Box>
      ))}
    </Box>
  );
};

export default RowFieldGroup;
